import * as React from 'react'

export const DownArrowIcon = ({
  onClick,
}: {
  onClick?: React.MouseEventHandler<SVGSVGElement>
}) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={'header-down-arrow-icon'}
    >
      <path
        d='M4 6L8 10L12 6'
        stroke='#64748B'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
